export const cosAttributes = {
  inbound: [
    {
      name: "cos",
      value: "",
      icon: "TextField",
    },
    {
      name: "dnd",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "vm",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "cfa",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "cfna",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "cfb",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "pr",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "fm",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "caf",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "cb",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "id",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "restrictFeatureAccess",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "acr",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "snmptrapEnabledOn",
      value: false,
      icon: "TextField",
    },
    {
      name: "callbackOnBusy",
      value: true,
      icon: "Checkbox",
    },
    {
      name: "callbackOnNoAnswer",
      value: true,
      icon: "Checkbox",
    },
    {
      name: "callbackOnNotRegistered",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "busyIndication",
      value: true,
      icon: "Checkbox",
    },
    {
      name: "overrideIBedTmf",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "allowgd",
      value: true,
      icon: "Checkbox",
    },
    {
      name: "allowTrunkInwardCall",
      value: true,
      icon: "Checkbox",
    },
    {
      name: "unma",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "campOn",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "autoRepeatDial",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "allowBossOnly",
      value: false,
      icon: "Checkbox",
    },
  ],
  outbound: [
    {
      name: "cos",
      value: "",
      icon: "TextField",
    },
    {
      name: "isd",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "std",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "loc",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "ic",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "cpe",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "cpg",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "arb",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "vmacs",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "sep",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "cf",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "bgn",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "id",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "gwOutBound",
      value: false,
      icon: "TextField",
    },
    {
      name: "ibe",
      value: true,
      icon: "Checkbox",
    },
    {
      name: "outBoundGroupGw",
      value: true,
      icon: "Checkbox",
    },
    {
      name: "acdPickup",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "parkConf",
      value: true,
      icon: "Checkbox",
    },
    {
      name: "trunkToTrunkTrFr",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "conferenceBeep",
      value: true,
      icon: "Checkbox",
    },
    {
      name: "extensionTransfer",
      value: true,
      icon: "Checkbox",
    },
    {
      name: "isConferenceModerator",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "cliInternalBlock",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "cliExternalBlock",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "secretaryBypass",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "trunkBArgIn",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "campOn",
      value: "",
      icon: "Checkbox",
    },
    {
      name: "allowPa",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "allowCallbackAfterHold",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "allowEmergencyConf",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "paging",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "allowTenant",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "whisper",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "gconfCall",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "dropCall",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "snmpTrapEnabledOn",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "cliForwardOnTransfer",
      value: true,
      icon: "Checkbox",
    },
    {
      name: "overRideIBedTmf",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "rdl",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "tac",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "allowExtensionService",
      value: true,
      icon: "Checkbox",
    },
    {
      name: "cb",
      value: true,
      icon: "Checkbox",
    },
    {
      name: "trunkFailOver",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "callPark",
      value: true,
      icon: "Checkbox",
    },
    {
      name: "longTalkBeep",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "transferRecall",
      value: true,
      icon: "Checkbox",
    },
    {
      name: "allowBgm",
      value: true,
      icon: "Checkbox",
    },
    {
      name: "allowgd",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "forcedDnd",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "manualDnd",
      value: false,
      icon: "Checkbox",
    },
    {
      name: "callForwardExternal",
      value: false,
      icon: "Checkbox",
    },
  ],
};
